import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { PlatformEndpoint } from './models/mocked-endpoint.model';
import { LoaderService } from '../../loader/loader.service';
import { PlataformCommunicatorBitacaraService } from './plataform-communicator-bitacara.service';

/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase PlatformCommunicatorInterceptor para interceptar peticiones Http
 *
 * *Defines PlatformCommunicatorInterceptor class to intercept http requests*
 *
 * @type {class}
 * @implements {HttpInterceptor}
 */
export class PlatformCommunicatorInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService, private plataformBitacora: PlataformCommunicatorBitacaraService) { }

  /**
   * Definición de la variable endpoints como PlatformEndpoint[] lista de endpoints cómo vacio
   *
   * *Defines endpoints variable as PlatformEndpoint[], empty endpoints list*
   *
   * @type {public}
   * @var {PlatformEndpoint[]} endpoints
   */
  endpoints: PlatformEndpoint[] = [];

  /**
   * Funcíon que inicializa la variable endpoints con los endpoint del parámetros
   *
   * *Function sets endpoints variable with endpoints in params*
   *
   * @type {function}
   * @param {PlatformEndpoint[]} endpoints
   */
  setMockedEndPoints(endpoints: PlatformEndpoint[]): void {
    this.endpoints = endpoints;
  }

  private matchURL(url: string, method: string): PlatformEndpoint | null {
    for (const endpoint of this.endpoints) {
      const regularExpression = new RegExp(endpoint.url);
      if (!regularExpression.test(url) || method.toLowerCase() !== endpoint.method.toLowerCase()) {
        continue;
      }

      return endpoint;
    }

    return null;
  }

  getBackEndURLMocked(urlMocked: string, url: string, method: string): string {
    const case_number = localStorage.getItem('case_number') !== null ? localStorage.getItem('case_number') : '0';

    const endpoint = this.matchURL(url, method);

    return endpoint !== null && !endpoint.mock_response && !endpoint.mock_error && endpoint.urlMocked !== undefined ?
      urlMocked + endpoint.urlMocked + case_number + '.json' : url;
  }

  /**
   * Funcíon que intercepta las peticiones http
   *
   * *Function intercepts http request*
   *
   * @type {function}
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable}
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestUrl = request.url;
    const endpoint = this.matchURL(requestUrl, request.method);

    const validatEndPoint = /.*\html?|json|event|cronostest$/.test(requestUrl);

    if (!validatEndPoint) {
      this.loaderService.show(requestUrl);
    }

    if (endpoint !== null && endpoint.mock_response) {
      this.loaderService.hide(requestUrl);
      return of(new HttpResponse({ status: endpoint.response.status, body: ((endpoint.response.body) as any) }));
    }

    return next.handle(request).pipe(
      map((_event: HttpEvent<any>) => {
        this.throwMockedError(request);

        if (_event instanceof HttpResponse && _event.body !== null && _event.body.status !== undefined) {
          if (_event.body.status === 200) {
            _event = _event.clone({ body: _event.body.body, status: _event.body.status });
          } else {
            const error = { status: _event.body.status, error: _event.body.body };
            throw (new HttpErrorResponse(error) as any);
          }
        }
        return _event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.plataformBitacora.saveDataInBitacora(error);
        this.loaderService.hide(requestUrl);
        this.throwMockedError(request);

        throw error;
      }),
      finalize(() => {
        this.loaderService.hide(requestUrl);
      }),
    );
  }

  /**
   * Funcíon para lanzar un error como mock
   *
   * *Function that throws mocked error*
   *
   * @type {function}
   * @type {private}
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable}
   */
  private throwMockedError(request: HttpRequest<any>): void {
    const endpoint = this.matchURL(request.url, request.method);
    if (endpoint !== null && endpoint.mock_error) {
      const error = { status: endpoint.errorResponse.status, error: endpoint.errorResponse.body };
      throw (new HttpErrorResponse(error) as any);
    }
  }
}
